import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from 'lodash';
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data);
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: 'landscape',
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: "25%",
              text: "",
            },
            {
              // fixed width
              width: "50%",
              alignment: "center",
              bold: true,
              text: [
                mainData.TITLE+"\n",
                "Del " + mainData.FI + " a " + mainData.FF + "\n",
              ],
            },
            {
              // % width
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
       {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: [50,100,20,40,60,30,50,40,"*","*",50,25],
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let times = [
      [
        {
          text: "Folio",
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Cliente", border: [true, true, true, true], fontSize: 12 },
        { text: "Ply", border: [true, true, true, true], fontSize: 12 },
        { text: "Salidas", border: [true, true, true, true], fontSize: 12 },
        {
          text: "Fecha",
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Hora", border: [true, true, true, true], fontSize: 12 },
        { text: "Estatus", border: [true, true, true, true], fontSize: 12 },
        { text: "Folio Venta", border: [true, true, true, true], fontSize: 12 },
        { text: "Notas", border: [true, true, true, true], fontSize: 12 },
        { text: "Agencia / Concierge", border: [true, true, true, true], fontSize: 12 },
        { text: "Total", border: [true, true, true, true], fontSize: 12 },
        { text: "Moneda", border: [true, true, true, true], fontSize: 12 },
       
      ],
    ];
    let groupedData = [];
    let total = 0;
    let totalCantidad = 0
    let orderedData = _.orderBy(data, ["date_format","time_format"], ["asc","asc"]);
    
    /*let grouper = "";
    orderedData.forEach((venta,index) => {
      if (grouper != venta.CategoriaName) {
        groupedData.push({
          header: true,
          text: venta.CategoriaName,
        });
      }
      groupedData.push(venta);
      total += Number(venta.Total)
      totalCantidad += Number(venta.Vendidos)
      grouper = venta.CategoriaName;

      if(orderedData[index+1]){
        if(orderedData[index+1].CategoriaName  != venta.CategoriaName ){
          groupedData.push({
            footer: true,
            text: 'Total',
            total:total,
            totalCantidad:totalCantidad
          });
          total = 0
          totalCantidad = 0
        }
      }else{
           groupedData.push({
            footer: true,
            text: 'Total',
            total:total,
            totalCantidad:totalCantidad
          });
          total = 0
          totalCantidad = 0
      }

    });*/

    orderedData.forEach((venta)=>{
      let rowToAdd = [];
      if(!venta.header & !venta.footer){
        let concierge =  (venta.Concierge != "")?" Concierge:"+venta.Concierge:""
        rowToAdd = [
          { text: venta.Folio, border: [true, true, false, false], fontSize: 10 },
          { text: venta.playerNombre, border: [true, true, false, false], fontSize: 10 },
          { text: venta.totalAccount , border: [true, true, false, false], fontSize: 10 },
          { text: venta.Salida, border: [true, true, false, false], fontSize: 10 },
          { text: venta.date_format, border: [true, true, false, false], fontSize: 10 },
          { text: venta.time_format, border: [true, true, false, false], fontSize: 10 },
          { text: venta.Estatus, border: [true, true, false, false], fontSize: 10 },
          { text: venta.FolioVenta, border: [true, true, false, false], fontSize: 10 },
          { text: venta.Notas, border: [true, true, false, false], fontSize: 10 },
          { text: venta.NombreHotel + concierge , border: [true, true, false, false], fontSize: 10 },
          { text: venta.Precio, border: [true, true, false, false], fontSize: 10 },
          { text: venta.Moneda, border: [true, true, true, false], fontSize: 10 },
        ]
        times.push(
            rowToAdd
        )
      }      
    })

    

    return times;
  }

  static getFirmas(data, porcentaje) {
    let times = [
      [
        { text: "Mesero", border: [true, true, true, true], fontSize: 12 },
        { text: "Total", border: [true, true, true, true], fontSize: 12 },
        {
          text: "%" + porcentaje,
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Firma", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    data.forEach((venta) => {
      let rowToAdd = [];
      if (venta.tipo == "footer") {
        rowToAdd = [
          {
            text: venta.Mesero,
            border: [true, true, true, true],
            fontSize: 10,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text:
              "$" +
              pgsHelper.formatNumber((venta.Total * Number(porcentaje)) / 100),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text: " ",
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "center",
          },
        ];
        times.push(rowToAdd);
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      heights: 60,
      table: {
        body: times,
      },
    };

    return times;
  }
}
